import { SxProps, Theme } from "@mui/material";

export const linksContainerStyles: SxProps<Theme> = {};

export const dividerWrapperStyles: SxProps<Theme> = {
    mt: 6,
    mb: 4,
};

export const sectionLogo: SxProps<Theme> = {
    maxWidth: "200px",
};

export const sectionTitle: SxProps<Theme> = {
    color: "white",
    fontWeight: 700,
    textTransform: "uppercase",
};
